/**
 * @generated SignedSource<<d2b6e27c5c7615255f6c38abb2656153>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContractStatus = "active" | "deleted" | "expired" | "offer_draft" | "offer_made" | "offer_processing" | "offer_rejected" | "offer_revoked" | "paused" | "rejected";
export type InvitationTypeEnum = "hire" | "invitation";
import { FragmentRefs } from "relay-runtime";
export type freelancer_useIsRejectabaleContract$data = {
  readonly invitationType: InvitationTypeEnum | null | undefined;
  readonly status: ContractStatus;
  readonly " $fragmentType": "freelancer_useIsRejectabaleContract";
};
export type freelancer_useIsRejectabaleContract$key = {
  readonly " $data"?: freelancer_useIsRejectabaleContract$data;
  readonly " $fragmentSpreads": FragmentRefs<"freelancer_useIsRejectabaleContract">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freelancer_useIsRejectabaleContract",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invitationType",
      "storageKey": null
    }
  ],
  "type": "Contract",
  "abstractKey": null
};

(node as any).hash = "7c7856ac564272b139a916488143c070";

export default node;
